/** @typedef {import('../index.js').InvalidDocData} InvalidDocData */
/** @typedef {import('./quote.js').QuoteDocData} QuoteDocData */

import getFeedbackSelections, { getDfmSelectionsString } from './getFeedbackSelections.js';
import Quote from './quote.js';

export {
  getQuoteAvailability,
  QuoteUnavailableMessages,
  QuoteUnavailableReasons,
} from './availability.js';

/**
 * Converts a Firestore document snapshot into a {@link Quote} instance.
 * @param {any} doc Raw Firestore document snapshot.
 * @returns {Quote | InvalidDocData} A {@link Quote} instance, or {@link InvalidDocData} on failure.
 */
function quoteFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return Quote.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming quote data:', docData.id, error);
    /** @type {InvalidDocData} */
    const InvalidDocData = { validation: 'failed', ...docData };
    return InvalidDocData;
  }
}

/**
 * Converts a {@link Quote} instance into a Firestore-compatible object.
 * @param {Quote} quote A {@link Quote} instance.
 * @returns {Omit<QuoteDocData, 'id'>} A Firestore data object (without `id`).
 */
function quoteToFirestore(quote) {
  return new Quote(quote).toFirestore();
}

export {
  Quote, // exported for TS type inference
  quoteFromFirestore,
  quoteToFirestore,
  getFeedbackSelections,
  getDfmSelectionsString,
};
